// src/services/cabadmin.js
// Wrapper axios pour les endpoints /copilot/cabadmin/* (interface DSI cabinet).
import axios from 'axios';
import { supabase } from '@/supabase/supabaseClient';

const BASE = (process.env.VUE_APP_API_URL || 'https://api.query-juriste.com') + '/copilot/cabadmin';

async function _authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getCabinet() {
  const headers = await _authHeaders();
  const { data } = await axios.get(`${BASE}/cabinet`, { headers });
  return data;
}

export async function listUsers({ status = 'all', search = '' } = {}) {
  const headers = await _authHeaders();
  const params = {};
  if (status && status !== 'all') params.status = status;
  if (search) params.search = search;
  const { data } = await axios.get(`${BASE}/users`, { headers, params });
  return data.users || [];
}

export async function addEmail(email, note) {
  const headers = await _authHeaders();
  const { data } = await axios.post(`${BASE}/allowlist`, { email, note }, { headers });
  return data;
}

export async function bulkAddEmails(emails) {
  const headers = await _authHeaders();
  const { data } = await axios.post(`${BASE}/allowlist/bulk`, { emails }, { headers });
  return data;
}

export async function removeEntry(allowlistId) {
  const headers = await _authHeaders();
  const { data } = await axios.delete(`${BASE}/allowlist/${allowlistId}`, { headers });
  return data;
}

export async function setSuspended(allowlistId, suspended) {
  const headers = await _authHeaders();
  const { data } = await axios.patch(
    `${BASE}/allowlist/${allowlistId}/suspend`,
    { suspended },
    { headers }
  );
  return data;
}

export async function getUsage(month) {
  const headers = await _authHeaders();
  const params = month ? { month } : {};
  const { data } = await axios.get(`${BASE}/usage`, { headers, params });
  return data;
}

export async function exportUsage(month) {
  const headers = await _authHeaders();
  const params = month ? { month } : {};
  return axios.get(`${BASE}/usage/export`, { headers, params, responseType: 'blob' });
}

export async function getActivity({ email = '', limit = 50 } = {}) {
  const headers = await _authHeaders();
  const params = { limit };
  if (email) params.email = email;
  const { data } = await axios.get(`${BASE}/activity`, { headers, params });
  return data;
}
